// extracted by mini-css-extract-plugin
export default {"content":"canceled_content__1JhlK","pay":"canceled_pay__UHrj-"};